import { useEffect } from 'react';
// import { createPortal } from 'react-dom';
// import { Message, Icon } from 'semantic-ui-react';
// import { defineMessages, useIntl } from 'react-intl';
// import { Link, useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
// import { default as Toolbar } from '@plone/volto/components/manage/Toolbar/Toolbar';
// import { default as Toast } from '@plone/volto/components/manage/Toast/Toast';
// import { Form } from '@plone/volto/components/manage/Form';
// import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
// import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
// import { emailNotification } from '@plone/volto/actions/emailNotification/emailNotification';
// import { usePrevious } from '@plone/volto/helpers/Utils/usePrevious';
// import { useClient } from '@plone/volto/hooks';
import { isManager } from '@plone/volto/helpers/User/User';
import { CONTACTS } from '../../../constants';

// const messages = defineMessages({
//   send: {
//     id: 'Send',
//     defaultMessage: 'Send',
//   },
//   contactForm: {
//     id: 'Contact form',
//     defaultMessage: 'Contact form',
//   },
//   default: {
//     id: 'Default',
//     defaultMessage: 'Default',
//   },
//   name: {
//     id: 'Name',
//     defaultMessage: 'Name',
//   },
//   from: {
//     id: 'From',
//     defaultMessage: 'From',
//   },
//   subject: {
//     id: 'Subject',
//     defaultMessage: 'Subject',
//   },
//   message: {
//     id: 'Message',
//     defaultMessage: 'Message',
//   },
//   error: {
//     id: 'Error',
//     defaultMessage: 'Error',
//   },
//   messageSent: {
//     id: 'Email sent',
//     defaultMessage: 'Email sent',
//   },
//   back: {
//     id: 'Back',
//     defaultMessage: 'Back',
//   },
//   success: {
//     id: 'Success',
//     defaultMessage: 'Success',
//   },
// });

// const useEmailNotification = () => {
//   const loading = useSelector((state) => state.emailNotification.loading);
//   const loaded = useSelector((state) => state.emailNotification.loaded);
//   const error = useSelector((state) => state.emailNotification.error);

//   return { loading, loaded, error };
// };

const ContactFormComponent = (props) => {
  // const location = useLocation();
  const { locale } = useSelector((state) => state.intl);
  // const dispatch = useDispatch();
  // const intl = useIntl();
  // const isClient = useClient();

  // const { loaded, loading, error } = useEmailNotification();

  // const prevloading = usePrevious(loading);

  // useEffect(() => {
  //   if (prevloading && loaded) {
  //     toast.success(
  //       <Toast
  //         success
  //         title={intl.formatMessage(messages.success)}
  //         content={intl.formatMessage(messages.messageSent)}
  //       />,
  //     );
  //   }
  // }, [intl, loaded, prevloading]);

  // const onSubmit = (data) => {
  //   const { from, message, name, subject } = data;
  //   dispatch(emailNotification(from, message, name, subject));
  // };

  const user = useSelector((state) => state.users.user);
  useEffect(() => {
    if (!isManager(user)) {
      window.location.href = `/${locale}/${CONTACTS[locale]}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // const onCancel = useCallback(() => {
  //   history.goBack();
  // }, [history]);

  return (
    <div id="page-contact" className="ui container">
      {/* <Helmet title={intl.formatMessage(messages.contactForm)} />
      <div className="contact-container">
        <h1>{intl.formatMessage(messages.contactForm)}</h1>
        {error && (
          <Message
            icon="warning"
            negative
            attached
            header={intl.formatMessage(messages.error)}
            content={error.message}
          />
        )}
        <Form
          onSubmit={onSubmit}
          // onCancel={onCancel}
          formData={{ blocksLayoutFieldname: {} }}
          submitLabel={intl.formatMessage(messages.send)}
          resetAfterSubmit
          loading={loading}
          schema={{
            fieldsets: [
              {
                fields: ['name', 'from', 'subject', 'message'],
                id: 'default',
                title: intl.formatMessage(messages.default),
              },
            ],
            properties: {
              name: {
                title: intl.formatMessage(messages.name),
                type: 'string',
              },
              from: {
                title: intl.formatMessage(messages.from),
                type: 'email',
              },
              subject: {
                title: intl.formatMessage(messages.subject),
                type: 'string',
              },
              message: {
                title: intl.formatMessage(messages.message),
                type: 'string',
                widget: 'textarea',
              },
            },
            required: ['from', 'message'],
          }}
        />
        {isClient &&
          createPortal(
            <Toolbar
              pathname={location.pathname}
              hideDefaultViewButtons
              inner={
                <Link to={`${getBaseUrl(location.pathname)}`} className="item">
                  <Icon
                    name="arrow left"
                    size="big"
                    color="blue"
                    title={intl.formatMessage(messages.back)}
                  />
                </Link>
              }
            />,
            document.getElementById('toolbar'),
          )}
      </div> */}
    </div>
  );
};

export default ContactFormComponent;
